import { PropsWithChildren } from "react";
import { ThemeProvider } from "styled-components";

export const theme = {
	colors: {
		appBlack: "#000000",
		activeIcon: "white",
		componentBackground: "#fff",
		backgroundInput: "#ffffff",
		backgroundPrimary: "#F9F9F9",
		body: "#f5f5f5",
		inputBorder: "#d8d5d5",
		inputBorderFocused: "#aaaaaa",
		inputError: "#d60d25",
		inputPlaceholder: "#afb2b8",
		itemBorder: "#a09fa7",
		lightItemBorder: "#EDEEF4",
		itemBorderLight: "#D8D5D5",
		scrollbarThumb: "#888",
		scrollbarThumbHover: "#555",
		textDetails: "#333333",
		textInput: "#1f1f1f",
		textPrimary: "#212121",
		textSecondary: "#8f8f8f",
		textError: "#ff0000",
		lightOrange: '#EC6728',
		darkOrange: '#B4501B',
		titleColor: "#54778E",
		placeholderColor: "#969BA0",
		inactiveText: "#CED6DC",
		hoverColor: "#F0F0F0",
		tableThBackground: "#F9FAFB",
		selectionBlue: "#EDEEF4",
		boxShadow: "#B2B2B240",
		green: "#98BA89",
		lightGray: '#95999a'
	},
	breakPointL: "1200px",
	breakPointM: "1024px",
	breakPointS: "768px",
	breakPointHeightL: "900px",
	breakPointHeightXL: "2200px",
};

const Theme = ({ children }: PropsWithChildren) => <ThemeProvider theme={theme}>{children}</ThemeProvider>;

export default Theme;
